/*
  ettore-cart-summary-fix.js
  --------------------------------------------------------------------------
  PROBLEMA:
  No cart drawer (cart.kt_cart_drawer.liquid) o "Subtotal" e os "Descontos"
  são calculados em Liquid usando compare_at_price (classes .cartSubtotalOriginal
  e .cartDiscountTotal), além da barra de frete grátis (#ettore-fs-container).
  O JS do tema (theme.ajax-cart.min.js > Shopify.KT_onCartUpdate_) só atualiza
  .cartCostTotal a partir do JSON do cart.js — que NÃO traz compare_at_price.
  Resultado: ao remover/alterar itens, Subtotal e Descontos ficam congelados.

  SOLUÇÃO:
  Envolvemos (wrap) Shopify.KT_onCartUpdate_ e, após cada atualização do
  carrinho, re-buscamos a view do drawer já renderizada pelo Liquid
  (?view=kt_cart_drawer) e trocamos APENAS o bloco de resumo e a barra de frete.
  Assim o cálculo continua 100% no Liquid (fonte única da verdade) e nada é
  duplicado em JS. Não altera o arquivo minificado do tema — sobrevive a updates.
  --------------------------------------------------------------------------
*/
(function () {
  'use strict';

  // Elementos do drawer que dependem de Liquid e precisam ser re-renderizados.
  // (o restante — lista de itens e Total a pagar — o tema já atualiza sozinho)
  var REFRESH_SELECTORS = [
    '#upadteCartCheckout table.table tbody', // Subtotal / Descontos / Total a pagar
    '#ettore-fs-container'                    // barra "Faltam R$X para frete grátis"
  ];

  function rootUrl() {
    if (window.Shopify && Shopify.routes && Shopify.routes.root) return Shopify.routes.root;
    if (window.Shopify && Shopify.root_url) {
      return Shopify.root_url.charAt(Shopify.root_url.length - 1) === '/'
        ? Shopify.root_url
        : Shopify.root_url + '/';
    }
    return '/';
  }

  // Troca o elemento inteiro (outerHTML) para também trazer estados como
  // o display:none que o Liquid aplica quando o carrinho fica vazio.
  function swapOuter(doc, selector) {
    var fresh = doc.querySelector(selector);
    var current = document.querySelector(selector);
    if (fresh && current && current.parentNode) {
      current.parentNode.replaceChild(fresh, current);
    }
  }

  var fetching = false;
  function refreshSummary() {
    if (fetching) return;
    fetching = true;
    var url = rootUrl() + 'cart?view=kt_cart_drawer';
    fetch(url, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin'
    })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        REFRESH_SELECTORS.forEach(function (sel) { swapOuter(doc, sel); });
      })
      .catch(function () { /* silencioso: em caso de falha, mantém o que já está na tela */ })
      .then(function () { fetching = false; });
  }

  function install() {
    if (!window.Shopify || typeof Shopify.KT_onCartUpdate_ !== 'function') {
      return setTimeout(install, 250); // espera o theme.ajax-cart.min.js carregar
    }
    if (Shopify.KT_onCartUpdate_.__ettoreWrapped) return;

    var original = Shopify.KT_onCartUpdate_;
    var wrapped = function () {
      var result = original.apply(this, arguments);
      // pequeno atraso para o DOM do tema assentar antes de re-renderizar o resumo
      setTimeout(refreshSummary, 60);
      return result;
    };
    wrapped.__ettoreWrapped = true;
    Shopify.KT_onCartUpdate_ = wrapped;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', install);
  } else {
    install();
  }
})();
